import httpClient from "@utils/httpClient";

export const getDailyAttendance = async (date = new Date().toISOString().split('T')[0]) => {
  try {
    const response = await httpClient.get(`/daily-tracker/attendance?date=${date}`);
    
    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getDailyAttendance error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};


export const getAttendanceSummary = async (date = new Date().toISOString().split('T')[0]) => {
  try {
    const response = await httpClient.get(`/daily-tracker/summary?date=${date}`);

    return {
      success: response.success,
      data: response.data || {},
      error: response.error
    };
  } catch (error) {
    console.error('getAttendanceSummary error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

export const getDailyTrackerCounts = async (date = new Date().toISOString().split('T')[0]) => {
  try {
    const response = await httpClient.get(`/daily-tracker/counts?date=${date}`);

    return {
      success: response.success,
      data: response.data || {},
      error: response.error
    };
  } catch (error) {
    console.error('getDailyTrackerCounts error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

export const getAbsentEmployees = async (date = new Date().toISOString().split('T')[0]) => {
  try {
    const response = await httpClient.get(`/daily-tracker/absent-employees?date=${date}`);

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getAbsentEmployees error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

export const getDailyUpdatesFeed = async (limit = 50) => {
  try {
    const response = await httpClient.get(`/daily-tracker/updates-feed?limit=${limit}`);

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getDailyUpdatesFeed error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

export const getDailyUpdatesByDate = async (date = new Date().toISOString().split('T')[0]) => {
  try {
    const response = await httpClient.get(`/daily-tracker/updates-by-date?date=${date}`);

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getDailyUpdatesByDate error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};




